import script from "./PublicOffersTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicOffersTable.vue?vue&type=script&setup=true&lang=js"

export default script